import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';
import modalMap from '../shared/components/modal-map/modal-map.view.html';

let inject = [
    '$scope',
    '$state',
    '$rootScope',
    'FooterCoreService',
    'SharedService',
    '$timeout',
    'ngAuthSettings',
    'SessionService',
    '$uibModal',
    '$mdToast',
    'ContactService'
];

class FooterCoreController {
    constructor($scope,
                $state,
                $rootScope,
                FooterCoreService,
                SharedService,
                $timeout,
                ngAuthSettings,
                SessionService,
                $uibModal,
                $mdToast,
                ContactService
    ) {
        this.$state = $state;
        this.SessionService = SessionService;
        this.ngAuthSettings = ngAuthSettings;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.SharedService = SharedService;
        this.cookiesAccepted = false;
        this.FooterCoreService = FooterCoreService;
        this.$uibModal = $uibModal;
        this.$mdToast = $mdToast;
        this.subscribe = {};
        this.emailPattern = '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,5}$';
        this.ContactService = ContactService;
        this.pageName = "B2B-PAG-3";
        this.SharedService.getCMSBanners(this.pageName).then(response => {
            this.cmsData = response;
        });
        this.contacts = [];
        if(__env.adaptative){
          this.adaptative=true;
        }
    }

    $onInit() {

        if(__env.adaptative){
            this.goTopVisibleAdpt();
        }

        this.cookiesAccepted = this.SessionService.get("enabledCookies");
        if(__env.clientName === "laskin"){
            this.getContactLocations();
        }
    }

    goToTop() {
        $('html, body').animate({
            'scrollTop': 0
        }, 1200);
    }


    goTopVisibleAdpt() {
        const goTopBtn = document.querySelector('#goTop');
        function goTop() {
            if (window.scrollY >= 500) {
                goTopBtn.classList.add("visible");
            } else {
                goTopBtn.classList.remove("visible");
            }
        }
        window.addEventListener('scroll', goTop);
    }


    scrollToTop(scrollDuration) {
        console.log("scroll")
    }




    enableCookies() {
        this.cookiesAccepted = true;
        this.SessionService.put("enabledCookies", true);
    };

    sendSuscribe(subscribeForm) {
        if (subscribeForm.$valid) {
        //<advertisement    sh-ctrl="$ctrl.shCtrl" type-content="espacios" positions="1"  page-name="PAG-16"></advertisement>
            this.SharedService.getCMSBanners('B2B-PAG-13').then(response => {
                this.contentData = response;
                let options = {
                    title: '',
                    isHtml: true,
                    content: "<small class='text-muted'> Al suscribirse acepta nuestra <strong>política de privacidad</strong>.</small>" +
                        "<md-content flex layout-padding class='terminos-y-condiciones mb10'>\n" +
                        this.contentData.espacios[1].html +
                        "               </md-content>",
                    size: '',
                    showBottonCancel: true,
                    textActionCancel: 'Cancelar',
                    textAction: 'Aceptar'
                };

                let modalInstance = this.$uibModal.open({
                    animation: true,
                    template: modalConfirmation,
                    controller: 'ModalResponseController',
                    controllerAs: 'mdCtrl',
                    size: options.size,
                    resolve: {
                        modalOptions: () => options
                    }
                });

                modalInstance.result.then(() => {

                    this.FooterCoreService.sendMailNewsletter(this.subscribe).then(response => {
                        if (!response.error) {
                            this.mailSent = true;
                            if (__env.adaptative) {
                                this.messageMaterial(response.message);
                            } else {
                                let options = {
                                    title: '',
                                    isHtml: true,
                                    content: response.message,
                                    size: '',
                                    showBottonCancel: false,
                                    textActionCancel: '',
                                    textAction: 'Aceptar'
                                };
                                this.messageResponse(options);
                            }
                            this.$timeout(() => {
                                this.mailSent = false;
                                this.sendingEmail = false
                            }, 3000)
                        }
                        else {
                            if (__env.adaptative) {
                                this.messageMaterial(response.message);
                            } else {
                                let options = {
                                    title: '',
                                    isHtml: true,
                                    content: response.message,
                                    size: '',
                                    showBottonCancel: false,
                                    textActionCancel: '',
                                    textAction: 'Aceptar'
                                };
                                this.messageResponse(options);
                            }
                        }
                    }).catch(reason => {
                        if (__env.adaptative) {
                            this.messageMaterial('Ha ocurrido un error al enviar el mensaje');
                        } else {
                            let options = {
                                title: '',
                                isHtml: false,
                                content: 'Ha ocurrido un error al enviar el mensaje',
                                size: '',
                                showBottonCancel: false,
                                textActionCancel: '',
                                textAction: 'Aceptar'
                            };
                            this.messageResponse(options);
                        }
                    });
                    this.subscribe.name = '';
                    this.subscribe.email = '';
                    this.subscribeForm.$setUntouched();
                    this.subscribeForm.$setPristine();
                });
            });


        } else {
            angular.forEach(subscribeForm.$error.required, function (field) {
                field.$setDirty();
            });
        }
    }

    messageMaterial(text){
    var mdToast=this.$mdToast;
    this.$mdToast.show({
      hideDelay   : 7000,
      controller  : function () {
        this.closeToast = function(){
          mdToast.hide();
        }

      },
      controllerAs:'toast',
      template : '<md-toast>\n' +
      '  <span class="md-toast-text">'+ text +'</span>\n' +
      '  <md-button ng-click="toast.closeToast()">\n' +
      '    Cerrar\n' +
      '  </md-button>\n' +
      '</md-toast>'
    });
  }

    getContactLocations() {
        this.ContactService.getContactLocations().then(response => {

            angular.forEach(response, (value, key) => {

                this.contacts.push({
                    name: key,
                    sedes: value
                });

            });

        }).catch(reason => {
            let options = {
                title: '',
                isHtml: false,
                content: 'Ha ocurrido un error obtener la informacion de contacto',
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
            };
            this.messageResponse(options);
        });
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }
}

FooterCoreController.$inject = inject;

export default FooterCoreController;




/** WEBPACK FOOTER **
 ** ./www/components/footer-core/footer-core.controller.js
 **/